import React from "react";


const Loading = () => {
  return (
    <div className="loading-container">
      <div className="loading-circle"></div>
      <p>Carregando...</p>
    </div>
  );
};

export default Loading;
